<template>
    <div class="bgred">
        <h2>契合科技营销产品矩阵，新金融，新营销</h2>
        <p>实施运营⼀条龙服务，让您省时省⼼做好数字化运营工作</p>
        <a @click="denglu" class="shiyong">立即试用</a>
    </div>
</template>

<script>
export default {
    props:{
       
    },
    data() {
        return {};
    },
    mounted() {
        var that = this;
        // this.common.mounted(that);
    },
    methods: {
        nolond() {}, denglu() {
            this.$router.push({
                path: "/login",
            });
        },
    },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/bgred.vue